




















import Vue from "vue"
import { Component } from "vue-property-decorator"

@Component
export default class HeaderDefaultComponent extends Vue {
    email = this.$api.User.Email;
}
